module.exports = __webpack_public_path__ + "media/flags/zm-6b8020db.svg";